export const getLoginFields = () => [
  {
    type: "text",
    name: "email",
    label: "Email",
  },
  {
    type: "password",
    name: "password",
    label: "Password",
  },
];

export const DEFAULT_USER_DATA = {
  email: "",
  password: "",
};
